'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gimweb_angular_service = require('../services/gimweb_angular_service.js');

var _gimweb_angular_service2 = _interopRequireDefault(_gimweb_angular_service);

var _location_service = require('../services/location_service.js');

var _location_service2 = _interopRequireDefault(_location_service);

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility.js');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _url_utility = require('../../../packages/common-utilities/src/url_utility.js');

var _url_utility2 = _interopRequireDefault(_url_utility);

var _functional_utility3 = require('../../../packages/common-utilities/src/functional_utility');

var _url_utility3 = require('../../../packages/common-utilities/src/url_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _fundsmarketing_aem_service = require('../services/fundsmarketing_aem_service');

var _fundsmarketing_aem_service2 = _interopRequireDefault(_fundsmarketing_aem_service);

var _modal = require('./global_components/modal');

var _modal2 = _interopRequireDefault(_modal);

var _dropdown_component = require('./global_components/dropdown_component');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _click_or_escape_outside = require('./click_or_escape_outside');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _state_service = require('../services/state_service');

var _state_service2 = _interopRequireDefault(_state_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);
var documentTag = _constants2.default.getFdTagConstants();

var getDefaultFactsheetKiidLang = function getDefaultFactsheetKiidLang(country, role) {
  var config = _constants2.default.getMultiLangQuickLinksConfig();
  var languages = (0, _functional_utility3.pathOrNull)([country, role], config);
  var defaultFactsheetKiidLang = 'EN';
  if (!(0, _functional_utility3.isNilOrEmpty)(languages)) {
    defaultFactsheetKiidLang = languages[0];
  }
  return defaultFactsheetKiidLang;
};

var InteractiveBox = function (_React$Component) {
  _inherits(InteractiveBox, _React$Component);

  function InteractiveBox(props) {
    _classCallCheck(this, InteractiveBox);

    var _this = _possibleConstructorReturn(this, (InteractiveBox.__proto__ || Object.getPrototypeOf(InteractiveBox)).call(this, props));

    _this.renderSubscriptionCTA = function () {
      if ((0, _ramda.includes)("SHOW_SUBSCRIPTION_TO_LITERATURE_CTA", _this.props.visibleDataPoints)) {
        return _this.renderGenericLink({
          docURL: "#documents",
          isGlassDoor: false,
          title: "Subscribe to product literature",
          iconSpanStyle: "icon-bell-cta pull-right position-relative",
          badgeText: _string_utility2.default.getLocalizedString(_this.props.intl, "NEW", 'pdp-cta-subscribe-to-product-literature-badge'),
          additionalElement: _this.renderPopover()
        }, null, {
          onMouseLeave: function onMouseLeave() {
            _this.setState({ showPopOver: false });
          },
          onMouseOver: function onMouseOver(event) {
            if ((0, _ramda.pathOr)("", ["target", "classList"], event).contains('icon-bell-cta')) {
              _this.setState({ showPopOver: true });
            } else {
              _this.setState({ showPopOver: false });
            }
          },
          onClick: function onClick() {
            _tracking_utility.TrackingUtility.trackEvent({
              "eventCategory": _tracking_utility.TrackingUtility.getEventCategory("pdp"),
              "eventAction": _tracking_utility.TrackingUtility.getEventAction("subscribeToProductLiteratureCta"),
              "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("clickUrl")
            });
            _state_service2.default.updateGlobalState({
              docTabActionSource: 'subscribeToProductCTA'
            });
          }
        });
      }
    };

    _this.renderPopover = function () {
      return _this.state.showPopOver && _react2.default.createElement(
        'div',
        { className: 'popover font-black-variant caption text-left', role: 'tooltip', 'aria-live': 'polite' },
        _react2.default.createElement(
          'p',
          { id: 'popover-description', tabIndex: 0 },
          _string_utility2.default.getLocalizedString(_this.props.intl, "Get notified when updated literature is available", 'pdp-cta-subscribe-to-product-literature')
        ),
        _react2.default.createElement('div', { className: 'popover-arrow', 'aria-hidden': 'true' })
      );
    };

    var defaultFactsheetKiidLang = getDefaultFactsheetKiidLang(_this.props.country, _this.props.role);
    _this.state = {
      compareFundClicked: false,
      bottomStyling: 0,
      showInteractiveBox: true,
      isAwardsAndRatingsAvailable: _this.props.isAwardsAndRatingsAvailable,
      isFavoriteFund: props.isFavoriteFund,
      modalStyle: 'none',
      modalType: 'interactive-box-favorite',
      selectedLangKiid: defaultFactsheetKiidLang,
      selectedLangFactsheet: defaultFactsheetKiidLang
    };
    _this.interactiveBoxRef = _react2.default.createRef();
    _gimweb_angular_service2.default.setAngularObject(props.window.angular);
    _location_service2.default.setTargetWindowObject(props.window);
    _this.navigateToCompareFundLink = _this.navigateToCompareFundLink.bind(_this);
    _this.hideInteractiveBox = true;
    return _this;
  }

  _createClass(InteractiveBox, [{
    key: 'renderSummaryProspectusLink',
    value: function renderSummaryProspectusLink() {
      var _this2 = this;

      var _props = this.props,
          cusip = _props.cusip,
          role = _props.role;

      if (this.props.fundTypeCode === "Commingled") {
        var commingledFundSummaryUrl = (0, _ramda.find)(function (doc) {
          return doc && doc.title === "Fund Summary";
        })((0, _url_utility3.getCommingledRegulatoryDocumentLinks)(cusip, role));

        return _react2.default.createElement(
          'li',
          { className: 'margin-bottom-15' },
          _react2.default.createElement(
            'a',
            { className: 'font-white  display-block width-percent-100 cursor-pointer-blue',
              'data-testid': 'fund-summary', href: (0, _functional_utility3.pathOrNull)(["docURL"], commingledFundSummaryUrl), target: '_blank' },
            'Fund Summary',
            _react2.default.createElement('span', { 'data-testid': 'fund-summary-icon',
              className: 'icon-quick-link pull-right' })
          )
        );
      } else if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SUMMARY_PROSPECTUS')) {

        var summaryProspectusLinkURL = _url_utility2.default.getSummaryProspectusURL(cusip, role);
        return _react2.default.createElement(
          'li',
          { className: 'margin-bottom-15' },
          _react2.default.createElement(
            'a',
            { className: 'font-white  display-block width-percent-100 cursor-pointer-blue',
              'data-testid': 'summary-prospectus',
              href: summaryProspectusLinkURL, onClick: function onClick() {
                return _this2.trackDownload(summaryProspectusLinkURL);
              },
              target: '_blank' },
            'Summary Prospectus',
            _react2.default.createElement('span', { 'data-testid': 'summary-prospectus-icon',
              className: 'icon-quick-link pull-right' })
          )
        );
      } else if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'PRODUCT_DISCLOSURE_STATEMENT')) {
        return this.renderGenericLink(this.props.aemDoc[documentTag.PRODUCT_DISCLOSURE_STATEMENT]);
      } else if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_AEM_SUMMARY_PROSPECTUS')) {
        if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'JP_ETF_SUMMARY_PROSPECTUS')) {
          return this.renderGenericLink({ docURL: _url_utility2.default.getSummaryProspectusURL(this.props.jpETFCusip, role),
            hardCodedLabel: _string_utility2.default.renderFormattedLabel("Summary Prospectus", "pdp-etf-summary-prospectus-label"),
            dataTestId: 'summary-prospectus',
            iconSpanStyle: 'icon-quick-link margin-bottom-5 pull-right position-relative'
          });
        } else {
          return this.renderGenericLink(this.props.aemDoc[documentTag.SUMMARY_PROSPECTUS]);
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var includeMorningStarToolsRole = !_collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesMorningStarToolsConstants(), this.props.role);

      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'JP_ETF_SUMMARY_PROSPECTUS') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'EMEA_TECHRULES_FACTSHEET') || !(0, _ramda.isNil)(this.props.fundDocuments) && !(0, _ramda.isNil)(this.props.fundDocuments.factSheetURL) || !(0, _functional_utility3.isNilOrEmpty)(this.props.factsheetUrl) || !(0, _functional_utility3.isNilOrEmpty)(this.props.aemDoc) || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'KIID') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'COMPARE_FUNDS') && includeMorningStarToolsRole && !(_location_service2.default.isMobile(this.props.basePath) || _location_service2.default.isMobileInsight(this.props.basePath)) || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'PDP_MULTI_LANGUAGE_QUICK_LINKS') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SUMMARY_PROSPECTUS') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'KID_DOCUMENT') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'PROSPECTUS') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'ETF_FACTS') || this.props.fundTypeCode === "Commingled") {

        if (!_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HIDE_INTERACTIVE_LINKS')) {
          this.hideInteractiveBox = false;
        }
      }

      this.hideInteractiveBoxIfRequired();
      this.updatePosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!(0, _ramda.equals)(this.props.isAwardsAndRatingsAvailable, this.state.isAwardsAndRatingsAvailable)) {
        this.updatePosition();
      }
    }
  }, {
    key: 'onChangeEvent',
    value: function onChangeEvent(dropdownType, language, url) {
      if (dropdownType === "kiid") {
        this.setState({
          selectedLangKiid: language
        });
      } else {
        this.setState({
          selectedLangFactsheet: language
        });
      }

      this.trackDownload(url);
    }
  }, {
    key: 'trackDownload',
    value: function trackDownload(url) {
      _tracking_utility.TrackingUtility.trackEvent(_tracking_utility.TrackingUtility.getDownloadsTracking(url, window.location.href));
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      if ((0, _ramda.isNil)(this.interactiveBoxRef.current)) {
        return false;
      }

      var node = _reactDom2.default.findDOMNode(this.interactiveBoxRef.current);
      if (!(0, _functional_utility3.isNilOrEmpty)(node) && !(0, _functional_utility3.isNilOrEmpty)(node.childNodes[0])) {
        var pdpHeaderHeight = (0, _ramda.isNil)(document.querySelector('#pdpHeader')) || !this.props.isAwardsAndRatingsAvailable ? 0 : document.querySelector('#pdpHeader').clientHeight;
        var jumpToFundHeight = (0, _ramda.isNil)(document.querySelector('#jump-to-fund')) ? 0 : document.querySelector('#jump-to-fund').clientHeight;
        var interactiveBoxHeight = (0, _ramda.isNil)(document.querySelector('#interactiveBox')) ? 0 : document.querySelector('#interactiveBox').clientHeight;
        this.setState({
          bottomStyling: ((!(0, _ramda.isNil)(this.props.fundIndustryCreditRatings.length) && this.props.fundIndustryCreditRatings.length > 0 ? 0 : pdpHeaderHeight) + jumpToFundHeight + interactiveBoxHeight) / 2 * -1,
          isAwardsAndRatingsAvailable: this.props.isAwardsAndRatingsAvailable
        });
      }
    }
  }, {
    key: 'renderGenericLink',
    value: function renderGenericLink(doc, formattedLabel) {
      var _this3 = this;

      var attr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { target: "_blank" };

      if ((0, _functional_utility3.isNilOrEmpty)(doc)) {
        return null;
      }

      var fundBold = (0, _ramda.isNil)(doc.fontWeight) ? '' : doc.fontWeight;
      var label = (0, _ramda.isNil)(doc.title) ? doc.hardCodedLabel : doc.title;
      var url = doc.docURL;
      var dataTestId = (0, _ramda.isNil)(doc.dataTestId) ? _string_utility2.default.customKebabCase(doc.title) : doc.dataTestId;
      var iconStyle = (0, _ramda.isNil)(doc.iconSpanStyle) ? 'icon-quick-link pull-right position-relative' : doc.iconSpanStyle;
      var labelSpanStyle = (0, _ramda.isNil)(doc.labelSpanStyle) ? 'padding-left-0 margin-bottom-5' : doc.labelSpanStyle;

      return _react2.default.createElement(
        'li',
        { className: 'margin-bottom-15' },
        _react2.default.createElement(
          'a',
          _extends({
            className: 'font-white display-block width-percent-100 cursor-pointer-blue', 'data-testid': dataTestId,
            href: url, onClick: function onClick() {
              return _this3.trackDownload(url);
            } }, attr),
          doc.badgeText && _react2.default.createElement(
            'span',
            { className: 'badge-icon' },
            doc.badgeText
          ),
          _react2.default.createElement(
            'span',
            {
              className: labelSpanStyle + ' ' + fundBold },
            label
          ),
          doc.additionalElement,
          _react2.default.createElement('span', { 'data-testid': dataTestId + '-icon',
            className: iconStyle })
        )
      );
    }
  }, {
    key: 'renderFactSheetLink',
    value: function renderFactSheetLink() {
      if ((0, _ramda.includes)("QUICK_LINK_SHOW_FUND_STORY", this.props.visibleDataPoints) && !(0, _functional_utility3.isNilOrEmpty)(this.props.aemDoc[documentTag.FUND_STORY]) && !(0, _ramda.includes)("QUICK_LINK_SHOW_FUND_STORY_WITH_FACTSHEET", this.props.visibleDataPoints)) {
        return null;
      }

      var doc = {};
      if (!(0, _ramda.isNil)(this.props.factsheetUrl) && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'EMEA_TECHRULES_FACTSHEET')) {
        doc = {
          docURL: this.props.factsheetUrl,
          hardCodedLabel: _string_utility2.default.renderFormattedLabel("Factsheet", "pdp-documents-fact-sheet-label", { role: this.props.role }),
          dataTestId: 'fact-sheet',
          iconSpanStyle: 'icon-quick-link pull-right',
          labelSpanStyle: ''
        };
      } else if (!(0, _functional_utility3.isNilOrEmpty)(this.props.aemDoc) && !_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HIDE_AEM_DOCUMENT')) {
        if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'OVERRIDE_FACTSHEET_LABEL') && !(0, _functional_utility3.isNilOrEmpty)(this.props.aemDoc[documentTag.FACT_SHEET])) {
          doc = {
            docURL: this.props.aemDoc[documentTag.FACT_SHEET].docURL,
            hardCodedLabel: _string_utility2.default.renderFormattedLabel("Factsheet", "pdp-documents-fact-sheet-label", { role: this.props.role }),
            dataTestId: 'fact-sheet',
            labelSpanStyle: 'no-wrap'
          };
        } else {
          return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            this.renderGenericLink(this.props.aemDoc[documentTag.FACT_SHEET]),
            this.renderGenericLink(this.props.aemDoc[documentTag.FACT_SHEET + "_zh"])
          );
        }
      } else if (!(0, _functional_utility3.isNilOrEmpty)(this.props.fundDocuments) && !(0, _functional_utility3.isNilOrEmpty)(this.props.fundDocuments.factSheetURL)) {
        doc = {
          docURL: this.props.fundDocuments.factSheetURL,
          hardCodedLabel: _string_utility2.default.renderFormattedLabel("Fact Sheet", "pdp-documents-fact-sheet-label", { role: this.props.role }),
          dataTestId: 'fact-sheet',
          iconSpanStyle: 'icon-quick-link pull-right',
          labelSpanStyle: ''
        };
      }
      if (!(0, _functional_utility3.isNilOrEmpty)(doc)) {
        return this.renderGenericLink(doc);
      }
    }
  }, {
    key: 'renderKIDLink',
    value: function renderKIDLink() {
      var _this4 = this;

      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'KID_DOCUMENT')) {
        var url = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHOW_AEM_DOCUMENT_LINK") && !(0, _ramda.isNil)(this.props.aemDoc['PRIIP KID']) ? this.props.aemDoc['PRIIP KID'].docURL : _url_utility2.default.generateKIDUrl(this.props.cusip, this.props.country, this.props.role, this.props.language, this.props.gaiaRedirectUrl);
        return _react2.default.createElement(
          'li',
          { className: 'margin-bottom-15' },
          _react2.default.createElement(
            'a',
            {
              className: 'font-white display-block width-percent-100 cursor-pointer-blue', 'data-testid': 'informationDocument-doc',
              id: 'kid-doc',
              href: url, onClick: function onClick() {
                return _this4.trackDownload(url);
              },
              target: '_blank' },
            'Information Document',
            _react2.default.createElement('span', { 'data-testid': 'fact-sheet-icon',
              className: 'icon-quick-link pull-right' })
          )
        );
      }
    }
  }, {
    key: 'renderKIIDLink',
    value: function renderKIIDLink() {
      var _this5 = this;

      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'KIID')) {
        var url = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHOW_AEM_DOCUMENT_LINK") && !(0, _ramda.isNil)(this.props.aemDoc['KIID-OEIC']) ? this.props.aemDoc['KIID-OEIC'].docURL : (0, _ramda.replace)("{gaiaRedirectUrl}", this.props.gaiaRedirectUrl, (0, _ramda.isNil)(this.props.kiidUrl) ? "" : this.props.kiidUrl);
        return _react2.default.createElement(
          'li',
          { className: 'margin-bottom-15' },
          _react2.default.createElement(
            'a',
            { className: 'font-white display-block width-percent-100 cursor-pointer-blue', 'data-testid': 'kiid',
              id: 'kiid',
              href: url, onClick: function onClick() {
                return _this5.trackDownload(url);
              },
              target: '_blank' },
            _string_utility2.default.renderFormattedLabel('KIID', 'pdp-kiid-label'),
            _react2.default.createElement('span', { 'data-testid': 'kiid-icon',
              className: 'icon-quick-link pull-right' })
          )
        );
      }
    }
  }, {
    key: 'renderPreferenceCentreLink',
    value: function renderPreferenceCentreLink() {
      var _this6 = this;

      if (!(0, _ramda.isNil)(this.props.aemDoc) && !(0, _ramda.isNil)(this.props.aemDoc[documentTag.PREFERENCE_CENTRE]) && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'PREFERENCE_CENTER')) {
        var url = this.props.aemDoc[documentTag.PREFERENCE_CENTRE].docURL;
        var label = this.props.aemDoc[documentTag.PREFERENCE_CENTRE].title;
        return _react2.default.createElement(
          'li',
          { className: 'margin-bottom-15' },
          _react2.default.createElement(
            'a',
            { className: 'font-white display-block width-percent-100 cursor-pointer-blue', 'data-testid': 'preferenceCentre',
              id: 'preferenceCentre',
              href: url, onClick: function onClick() {
                return _this6.trackDownload(url);
              },
              target: '_blank' },
            !(0, _functional_utility3.isNilOrEmpty)(label) ? label : _string_utility2.default.renderFormattedLabel('Preference Centre', 'pdp-preferenceCentre-label'),
            _react2.default.createElement('span', { 'data-testid': 'preferenceCentre-icon',
              className: 'icon-quick-link pull-right' })
          )
        );
      }
    }
  }, {
    key: 'renderHowToBuyLink',
    value: function renderHowToBuyLink() {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HOW_TO_BUY') && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_HOW_TO_INVEST_CARD')) {
        return this.renderInternalHowToLink("how-to-invest", "How to invest");
      } else if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HOW_TO_BUY') && !(0, _ramda.isNil)(this.props.howToBuyLink)) {
        if (this.props.isAEM && !(0, _ramda.isNil)(this.props.howToInvestLink)) {
          var howToInvestAEMLink = this.props.howToInvestLink.replace("/gim", "").replace("adv", this.props.role);
          return this.renderHowToLink("how-to-invest", howToInvestAEMLink, "How to invest");
        }
        return this.renderHowToLink("how-to-buy", this.props.howToBuyLink, "How to buy");
      }
    }
  }, {
    key: 'renderHowToInvestLink',
    value: function renderHowToInvestLink() {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HOW_TO_INVEST') && !(0, _ramda.isNil)(this.props.howToInvestLink)) {
        if (this.props.isAEM) {
          var howToInvestAEMLink = this.props.howToInvestLink.replace("/gim", "").replace("adv", this.props.role);
          return this.renderHowToLink("how-to-invest", howToInvestAEMLink, "How to invest");
        }
        return this.renderHowToLink("how-to-invest", this.props.howToInvestLink, "How to invest");
      }
    }
  }, {
    key: 'renderHowToBuyETFsLink',
    value: function renderHowToBuyETFsLink() {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HOW_TO_BUY_ETF') && !(0, _ramda.isNil)(this.props.howToBuyETFLink)) {
        return this.renderHowToLink("how-to-buy-etf", this.props.howToBuyETFLink, "How to buy ETFs");
      }
    }
  }, {
    key: 'renderViivMethodologyLink',
    value: function renderViivMethodologyLink() {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_VIIV_METHODOLOGY_IN_QUICK_LINK')) {
        var _document = _url_utility2.default.getDocumentsByCategory(this.props.fundDocuments.documents, "VIIV Methodology");
        return (0, _functional_utility3.isNilOrEmpty)(_document) ? null : this.renderHowToLink("viiv-methodology", _document.docURL, _document.title, "icon-copyto");
      }
    }
  }, {
    key: 'renderHowToLink',
    value: function renderHowToLink(id, link, displayText) {
      var icon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'icon-quick-link';

      var className = icon + ' pull-right';
      return _react2.default.createElement(
        'li',
        { className: 'margin-bottom-15' },
        _react2.default.createElement(
          'a',
          {
            className: 'font-white display-block width-percent-100 cursor-pointer-blue', 'data-testid': id + '-link',
            id: id + '-link',
            href: link,
            target: '_blank' },
          displayText,
          _react2.default.createElement('span', { 'data-testid': id + '-icon',
            className: className })
        )
      );
    }
  }, {
    key: 'renderInternalHowToLink',
    value: function renderInternalHowToLink(id, displayText) {
      var _this7 = this;

      var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'icon-quick-link';

      var className = icon + ' pull-right';
      return _react2.default.createElement(
        'li',
        { className: 'margin-bottom-15' },
        _react2.default.createElement(
          'a',
          {
            className: 'font-white display-block width-percent-100 cursor-pointer-blue', 'data-testid': id + '-link',
            onClick: function onClick() {
              return _functional_utility2.default.scrollToCard(window.document, 'overview', 'howToInvestCard', _this7.props.breakpoint);
            } },
          displayText,
          _react2.default.createElement('span', { 'data-testid': id + '-icon',
            className: className })
        )
      );
    }
  }, {
    key: 'renderComparefund',
    value: function renderComparefund() {
      var _this8 = this;

      var includeMorningStarToolsRole = !_collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesMorningStarToolsConstants(), this.props.role);
      var isMobile = _location_service2.default.isMobile(this.props.basePath) || _location_service2.default.isMobileInsight(this.props.basePath);
      var items = [];
      if ((0, _ramda.and)(includeMorningStarToolsRole, !isMobile)) {
        (0, _ramda.and)(_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'COMPARE_FUNDS'), !(0, _ramda.isNil)(this.props.compareFundLink)) ? items.push(_react2.default.createElement(
          'li',
          { key: 'compare-fund',
            className: 'margin-bottom-15 ' + _functional_utility2.default.conditionCheck(this.state.compareFundClicked, "compareFundClicked", ""),
            'data-testid': 'compare-fund',
            onClick: function onClick() {
              return _this8.navigateToCompareFundLink();
            } },
          _react2.default.createElement(
            'a',
            { className: 'font-white display-block width-percent-100 cursor-pointer-blue', href: '#' },
            _react2.default.createElement(
              'span',
              null,
              'Compare Fund'
            ),
            _react2.default.createElement('span', {
              className: 'icon-quick-link pull-right' })
          )
        )) : null;
        return items.length > 0 ? items : null;
      }
      return null;
    }
  }, {
    key: 'navigateToCompareFundLink',
    value: function navigateToCompareFundLink() {
      window.open(this.props.compareFundLink, "_blank");
    }
  }, {
    key: 'hideInteractiveBoxIfRequired',
    value: function hideInteractiveBoxIfRequired() {
      if (this.hideInteractiveBox) {
        this.setState({ showInteractiveBox: false });
      }
    }
  }, {
    key: 'focusItemForReference',
    value: function focusItemForReference(refString) {
      this[refString].current.focus();
    }
  }, {
    key: 'focusNextItem',
    value: function focusNextItem(refString) {
      this[refString].current.nextElementSibling.focus();
    }
  }, {
    key: 'focusPreviousItem',
    value: function focusPreviousItem(refString) {
      this[refString].current.previousElementSibling.focus();
    }
  }, {
    key: 'dropDownItems',
    value: function dropDownItems(dropdownType, languages) {
      var _this9 = this;

      var lastLanguage = languages[languages.length - 1] ? languages[languages.length - 1] : "";
      return mapIndexed(function (language, index) {
        _this9[language + '-' + dropdownType + '-documentDropdown'] = _react2.default.createRef();
        var href = dropdownType === 'factsheet' ? _url_utility2.default.generateFactSheetURLForNonUSCountry(_this9.props.cmsShare, _this9.props.country, _this9.props.role, language) : _url_utility2.default.generateKIIDURLForNonUSCountry(_this9.props.cusip, _this9.props.country, _this9.props.role, language);

        return _react2.default.createElement(
          'a',
          { ref: _this9[language + '-' + dropdownType + '-documentDropdown'], 'data-option-value': index, 'data-display-value': language, className: 'quicklinks-' + dropdownType + '-dropdown-list-item-' + index, target: '_blank', onClick: function onClick() {
              return _this9.onChangeEvent(dropdownType, language, href);
            }, href: href },
          _react2.default.createElement(
            'div',
            {
              'data-option-value': index,
              'data-display-value': language,
              tabIndex: 0,
              key: language,
              'data-language': language,
              className: 'disclaimer dropdown-list-item font-black padding-all-18 width-100pct',
              'data-testid': 'dropdown-' + dropdownType,
              role: 'option',
              onKeyDown: function onKeyDown(e) {

                if (e.key !== "Tab") {
                  e.preventDefault();
                }

                if (e.key === "Tab" && !e.shiftKey && lastLanguage === language) {
                  if ((0, _ramda.indexOf)("clicked", document.querySelector("#" + dropdownType + "-dropdown .dropdown-display-header-docs").classList) === 1) {
                    document.querySelector("#" + dropdownType + "-dropdown .dropdown-display-header-docs .icon-up-arrow").click();
                  }
                }

                if (e.key === "Tab" && e.shiftKey && lastLanguage === language) {
                  if ((0, _ramda.indexOf)("clicked", document.querySelector("#" + dropdownType + "-dropdown .dropdown-display-header-docs").classList) === -1) {
                    document.querySelector("#" + dropdownType + "-dropdown .npe-icon-down-arrow").click();
                  }
                }

                if (e.key === "Enter") {
                  _this9.onChangeEvent(dropdownType, language, href);
                }

                if (e.key === "ArrowDown") {
                  if ((0, _ramda.isNil)(_this9[language + '-' + dropdownType + '-documentDropdown'].current.nextElementSibling)) {
                    _this9.focusItemForReference(dropdownType + '-dropdown');
                  } else {
                    _this9.focusNextItem(language + '-' + dropdownType + '-documentDropdown');
                  }
                }

                if (e.key === "ArrowUp") {
                  if ((0, _ramda.isNil)(_this9[language + '-' + dropdownType + '-documentDropdown'].current.previousElementSibling)) {
                    _this9.focusItemForReference(language + '-' + dropdownType + '-documentDropdown');
                  } else {
                    _this9.focusPreviousItem(language + '-' + dropdownType + '-documentDropdown');
                  }
                }
              }
            },
            language
          )
        );
      }, languages);
    }
  }, {
    key: 'setRef',
    value: function setRef(refId) {
      var _this10 = this;

      return function (el) {
        return _this10[refId] = el;
      };
    }
  }, {
    key: 'renderMultiLanguageQuickLinks',
    value: function renderMultiLanguageQuickLinks(interactiveBoxMarkup) {
      var _this11 = this;

      var config = _constants2.default.getMultiLangQuickLinksConfig();
      var languages = (0, _functional_utility3.pathOrNull)([this.props.country, this.props.role], config);
      if ((0, _functional_utility3.isNilOrEmpty)(languages)) {
        return interactiveBoxMarkup;
      }

      var factsheetOptions = this.dropDownItems('factsheet', languages);
      var kiidOptions = this.dropDownItems('kiid', languages);

      var hrefFactsheet = _url_utility2.default.generateFactSheetURLForNonUSCountry(this.props.cmsShare, this.props.country, this.props.role, this.state.selectedLangFactsheet);
      var hrefKiid = _url_utility2.default.generateKIIDURLForNonUSCountry(this.props.cusip, this.props.country, this.props.role, this.state.selectedLangKiid);

      var factSheetHeader = _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'span',
          {
            'data-testid': 'interactive-box-multi-lang-factsheet-label',
            className: "font-white display-block width-percent-100 padding-vertical-18" },
          _string_utility2.default.renderFormattedLabel("Fact Sheet", "pdp-documents-fact-sheet-label"),
          _react2.default.createElement(
            'a',
            { target: '_blank', onClick: function onClick() {
                return _this11.onChangeEvent('factsheet', _this11.state.selectedLangFactsheet, hrefFactsheet);
              }, href: hrefFactsheet },
            _react2.default.createElement('span', { 'data-testid': 'interactive-box-multi-lang-icon',
              className: "icon-quick-link pull-right position-relative padding-left-5" }),
            ' '
          ),
          _react2.default.createElement(
            _click_or_escape_outside2.default,
            {
              id: 'dropdownfactsheet',
              additionalClassName: "float-right display-inline-block",
              onClose: this.onClose
            },
            _react2.default.createElement(_dropdown_component2.default, { id: 'factsheet-dropdown',
              breakpoint: this.props.breakpoint,
              dropdownContent: factsheetOptions,
              isHeader: true,
              isDocs: true,
              initialActiveSelect: this.state.selectedLangFactsheet,
              setRef: this.setRef('factsheet-documentDropdown'),
              dropdownWidth: '82px' })
          ),
          _react2.default.createElement(
            'a',
            { target: '_blank', onClick: function onClick() {
                return _this11.onChangeEvent('factsheet', _this11.state.selectedLangFactsheet, hrefFactsheet);
              }, href: hrefFactsheet },
            _react2.default.createElement('span', { 'data-testid': 'interactive-box-multi-lang-icon-globe',
              className: "icon-quick-link-globe pull-right position-relative padding-right-5" })
          )
        )
      );
      var kiidHeader = _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'span',
          {
            'data-testid': 'interactive-box-multi-lang-kiid-label',
            className: "font-white display-block width-percent-100 padding-vertical-18" },
          _string_utility2.default.renderFormattedLabel('KIID', 'pdp-kiid-label'),
          _react2.default.createElement(
            'a',
            { target: '_blank', onClick: function onClick() {
                return _this11.onChangeEvent('kiid', _this11.state.selectedLangKiid, hrefKiid);
              }, href: hrefKiid },
            _react2.default.createElement('span', { 'data-testid': 'interactive-box-multi-lang-icon',
              className: "icon-quick-link pull-right position-relative padding-left-5" })
          ),
          _react2.default.createElement(
            _click_or_escape_outside2.default,
            {
              id: 'dropdownkiid',
              additionalClassName: "float-right display-inline-block",
              onClose: this.onClose
            },
            _react2.default.createElement(_dropdown_component2.default, { id: 'kiid-dropdown',
              breakpoint: this.props.breakpoint,
              dropdownContent: kiidOptions,
              isHeader: true,
              isDocs: true,
              initialActiveSelect: this.state.selectedLangKiid,
              setRef: this.setRef('kiid-documentDropdown'),
              dropdownWidth: '82px' })
          ),
          _react2.default.createElement(
            'a',
            { target: '_blank', onClick: function onClick() {
                return _this11.onChangeEvent('kiid', _this11.state.selectedLangKiid, hrefKiid);
              }, href: hrefKiid },
            _react2.default.createElement('span', { 'data-testid': 'interactive-box-multi-lang-icon-globe',
              className: "icon-quick-link-globe pull-right position-relative padding-right-5" })
          )
        )
      );

      return _react2.default.createElement(
        'ul',
        { 'data-testid': 'interactiveLinks',
          className: 'interactiveList quick-links padding-all-0 margin-bottom-0 width-percent-100 mergin-vertical-18' },
        _react2.default.createElement(
          'div',
          null,
          _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'EMEA_TECHRULES_FACTSHEET') ? factSheetHeader : null
        ),
        _react2.default.createElement(
          'div',
          null,
          kiidHeader
        )
      );
    }
  }, {
    key: 'renderCommentaryLink',
    value: function renderCommentaryLink() {
      if ((0, _ramda.includes)("COMMENTARY_LINK", this.props.visibleDataPoints)) {
        return this.renderGenericLink(this.props.aemDoc[documentTag.COMMENTARY]);
      }
    }
  }, {
    key: 'renderETFFactsLink',
    value: function renderETFFactsLink() {
      if ((0, _ramda.includes)("ETF_FACTS", this.props.visibleDataPoints)) {
        var ETFFactsCategory = 'FS';
        var docType = this.props.intl.formatMessage({
          id: 'pdp-etf-doc-label-' + ETFFactsCategory,
          defaultMessage: ""
        });
        return this.renderGenericLink({
          title: docType,
          docURL: (0, _url_utility.getCADFSURL)(this.props.cusip, this.props.language, ETFFactsCategory),
          documentType: docType
        }, docType);
      }
      return null;
    }
  }, {
    key: 'renderProspectusLink',
    value: function renderProspectusLink() {
      var _this12 = this;

      if ((0, _ramda.includes)("PROSPECTUS_DOCUMENT", this.props.visibleDataPoints)) {
        return this.renderGenericLink(this.props.aemDoc[documentTag.PROSPECTUS], _string_utility2.default.renderFormattedLabel("Prospectus Document", "pdp-prospectus-document-label"));
      } else if ((0, _ramda.includes)("PROSPECTUS", this.props.visibleDataPoints)) {
        var _props2 = this.props,
            cusip = _props2.cusip,
            role = _props2.role;

        var prospectusLinkURL = _url_utility2.default.getProspectusURL(cusip, role);
        return _react2.default.createElement(
          'li',
          { className: 'margin-bottom-15' },
          _react2.default.createElement(
            'a',
            { className: 'font-white  display-block width-percent-100 cursor-pointer-blue',
              'data-testid': 'prospectus',
              href: prospectusLinkURL, onClick: function onClick() {
                return _this12.trackDownload(prospectusLinkURL);
              },
              target: '_blank' },
            'Prospectus',
            _react2.default.createElement('span', { 'data-testid': 'prospectus-icon',
              className: 'icon-quick-link pull-right' })
          )
        );
      }
    }
  }, {
    key: 'renderInvestorDisclosureDocumentLink',
    value: function renderInvestorDisclosureDocumentLink() {
      if ((0, _ramda.includes)("INVESTOR_DISCLOSURE_DOCUMENT", this.props.visibleDataPoints)) {
        return this.renderGenericLink(this.props.aemDoc[documentTag.INVESTOR_DISCLOSURE_DOCUMENT], _string_utility2.default.renderFormattedLabel("Investor Disclosure Document", "pdp-investor-disclosure-document-label"));
      }
    }
  }, {
    key: 'renderFundStoryLink',
    value: function renderFundStoryLink() {
      if ((0, _ramda.includes)("QUICK_LINK_SHOW_FUND_STORY", this.props.visibleDataPoints)) {
        return this.renderGenericLink(this.props.aemDoc[documentTag.FUND_STORY], _string_utility2.default.renderFormattedLabel("Fund Story", "pdp-fund-story-label"));
      }
    }
  }, {
    key: 'renderFundStoryWithFactSheetLink',
    value: function renderFundStoryWithFactSheetLink() {
      if ((0, _ramda.includes)("QUICK_LINK_SHOW_FUND_STORY_WITH_FACTSHEET", this.props.visibleDataPoints)) {
        return this.renderGenericLink(this.props.aemDoc[documentTag.FUND_STORY], _string_utility2.default.renderFormattedLabel("Fund Story", "pdp-fund-story-label"));
      }
    }
  }, {
    key: 'addFundToFavorites',
    value: function addFundToFavorites(addToFavorite) {
      var _this13 = this;

      var trackingAction = addToFavorite ? "addToFavorites" : "removeFromFavorites";
      _tracking_utility.TrackingUtility.trackEvent(_tracking_utility.TrackingUtility.getFundFavoriteTracking("pdp", trackingAction, this.props.fundDisplayName));

      if (this.props.userLoggedIn !== true) {
        _fundsmarketing_aem_service2.default.invokeLoginModal();
      } else if (addToFavorite) {
        this.setState({ modalStyle: 'inline-block', modalType: 'interactive-box-favorite' });
        _fundsmarketing_aem_service2.default.addToCollection(this.props.cusip).then(function (data) {
          !(0, _ramda.isNil)(data) ? _this13.setState({ isFavoriteFund: true }) : null;
          _this13.setState({ modalStyle: 'none' });
        });
      } else {
        this.setState({ modalStyle: 'inline-block', modalType: 'interactive-box-favorite' });
        _fundsmarketing_aem_service2.default.removeFromCollection(this.props.cusip).then(function (data) {
          !(0, _ramda.isNil)(data) ? _this13.setState({ isFavoriteFund: false }) : null;
          _this13.setState({ modalStyle: 'none' });
        });
      }
    }
  }, {
    key: 'renderModal',
    value: function renderModal() {
      if (!_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_FUND_FAVORITE_LINK')) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { 'data-testid': this.state.modalType + '-modal' },
        _react2.default.createElement(_modal2.default, { display: this.state.modalStyle,
          type: 'favorite',
          gaiaRedirectUrl: this.props.gaiaRedirectUrl })
      );
    }
  }, {
    key: 'renderFundFavoriteLink',
    value: function renderFundFavoriteLink() {
      var _this14 = this;

      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_FUND_FAVORITE_LINK')) {
        var link = void 0;
        if (this.state.isFavoriteFund === true && this.props.userLoggedIn === true) {
          link = _react2.default.createElement(
            'a',
            {
              className: 'font-white display-block width-percent-100 cursor-pointer-blue',
              'data-testid': "remove-from-favorites-icon", onClick: function onClick() {
                return _this14.addFundToFavorites(false);
              } },
            _string_utility2.default.renderFormattedLabel("Remove from favorites", "fx-pdp-remove-from-favorites-label"),
            _react2.default.createElement('span', {
              className: 'icon-remove-from-fav pull-right' })
          );
        } else {
          link = _react2.default.createElement(
            'a',
            {
              className: 'font-white display-block width-percent-100 cursor-pointer-blue',
              'data-testid': "add-to-favorites-icon", onClick: function onClick() {
                return _this14.addFundToFavorites(true);
              } },
            _string_utility2.default.renderFormattedLabel("Add to favorites", "fx-pdp-add-to-favorites-label"),
            _react2.default.createElement('span', {
              className: 'icon-add-to-fav pull-right' })
          );
        }

        return _react2.default.createElement(
          'li',
          { 'data-testid': "fund-favorite-quick-link" },
          link
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.breakpoint < 3) {
        return null;
      }

      var interactiveBoxMarkup = _react2.default.createElement(
        'ul',
        { 'data-testid': 'interactiveLinks',
          className: 'interactiveList quick-links padding-all-0 margin-bottom-0 width-percent-100' },
        this.renderSubscriptionCTA(),
        this.renderPreferenceCentreLink(),
        this.renderFundStoryLink(),
        this.renderFactSheetLink(),
        this.renderETFFactsLink(),
        this.renderProspectusLink(),
        this.renderFundStoryWithFactSheetLink(),
        this.renderInvestorDisclosureDocumentLink(),
        this.renderCommentaryLink(),
        this.renderKIIDLink(),
        this.renderKIDLink(),
        this.renderHowToBuyLink(),
        this.renderHowToInvestLink(),
        this.renderSummaryProspectusLink(),
        this.renderHowToBuyETFsLink(),
        this.renderComparefund(),
        this.renderViivMethodologyLink(),
        this.renderFundFavoriteLink(),
        this.renderModal()
      );

      interactiveBoxMarkup = this.renderMultiLanguageQuickLinks(interactiveBoxMarkup);

      var adjustClassName = 'interactiveBoxContent ' + (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'COMMENTARY_LINK') && this.props.breakpoint <= 3 ? 'width-percent-80' : 'width-percent-100') + ' pull-right border-top-none';

      return _react2.default.createElement(
        'div',
        { 'data-testid': 'interactive-box-container',
          className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 position-relative print-hide'
        },
        _react2.default.createElement(
          'div',
          { id: 'interactiveBox',
            className: 'interactiveBox width-percent-100 pull-right' },
          this.props.renderJumpToFundApp(),
          this.state.showInteractiveBox && !(0, _functional_utility3.isNilOrEmpty)(interactiveBoxMarkup) && !(0, _functional_utility3.allValuesNil)(interactiveBoxMarkup.props.children) && _react2.default.createElement(
            _card_component2.default,
            {
              hideHeader: true,
              hideWhiteBackground: true,
              ref: this.interactiveBoxRef,
              className: adjustClassName,
              allowOverflow: true
            },
            interactiveBoxMarkup
          )
        )
      );
    }
  }]);

  return InteractiveBox;
}(_react2.default.Component);

exports.default = InteractiveBox;